import {computed, onMounted, onUnmounted, ref} from 'vue';

export const useWindowDimensions = () => {
    const windowWidth = ref(window.innerWidth);

    function getWindowDimensions() {
        return window.innerWidth;
    }

    function handleResize() {
        windowWidth.value = getWindowDimensions();
    }

    const currentWindowDimensions = computed(() => ({
        isMobileDefaultSmallest: windowWidth.value > 320,
        isMobileDefaultSmaller: windowWidth.value > 368,
        isMobileDefaultSmall: windowWidth.value > 400,
        isMobileDefault: windowWidth.value > 480,
        isTabletDefaultSmall: windowWidth.value > 667,
        isTabletDefault: windowWidth.value > 768,
        isTabletSmall: windowWidth.value > 830,
        isTablet: windowWidth.value > 1024,
        isTabletLong: windowWidth.value > 1280,
        laptopXL_1: windowWidth.value > 1460
    }));

    onMounted(() => {
        window.addEventListener('resize', handleResize);
    });

    onUnmounted(() => {
        window.removeEventListener('resize', handleResize);
    });

    return {
        ...currentWindowDimensions.value
    };
};
